import { toast } from "$global-providers/toast-provider";
import { gql } from "@apollo/client";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { paginationDefaults } from "../_lib/constant";
import {
  FetchRegisterDownloadRequestsDocument,
  type FetchRegisterDownloadRequestsQuery,
  type FetchRegisterDownloadRequestsQueryVariables,
} from "../download-requests/__generated__/page.gql";
import { linkToRegistersDownloadRequests } from "../links";
import { useRequestRegisterDownloadMutation } from "./__generated__/use-request-download.gql";

gql`
  mutation RequestRegisterDownload($input: RequestRegisterDownloadInput!) {
    requestRegisterDownload(input: $input) {
      ...DownloadRequestFragment
    }
  }
`;

export const useRequestDownload = () => {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  return useRequestRegisterDownloadMutation({
    onCompleted: () => {
      navigate(linkToRegistersDownloadRequests());
    },
    onError: (err) => {
      if (
        err.graphQLErrors[0].extensions.code ===
        "DUPLICATE_DOWNLOAD_REQUEST_ERROR"
      ) {
        toast.info(
          formatMessage({
            id: "register.downloadRequest.duplicate",
            defaultMessage:
              "A download request for this already exists, redirecting...",
          }),
        );
        navigate(linkToRegistersDownloadRequests());
      } else {
        toast.error(
          formatMessage({
            id: "register.downloadRequest.error",
            defaultMessage: "Failed to request register download",
          }),
        );
      }
    },
    update: (cache, res) => {
      if (res.data?.requestRegisterDownload) {
        cache.updateQuery<
          FetchRegisterDownloadRequestsQuery,
          FetchRegisterDownloadRequestsQueryVariables
        >(
          {
            query: FetchRegisterDownloadRequestsDocument,
            variables: { input: { paginationOptions: paginationDefaults } },
          },
          (cachedData) => {
            if (cachedData) {
              return {
                registerDownloadRequests: {
                  ...cachedData.registerDownloadRequests,
                  requests: [
                    res.data.requestRegisterDownload,
                    ...cachedData.registerDownloadRequests.requests,
                  ],
                },
              };
            }

            return null;
          },
        );
      }
    },
  });
};
